import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, BusinessBenefitsContainer, BusinessBenefitsContent } from './pataPay.styled';

const { VITE_CDN_BASE_URL } = getEnv();

export const PataPay = () => {
  const navigate = useNavigate();

  const handlePataPayLink = () => {
    navigate('/business/pata-pay');
  };

  return (
    <BusinessBenefitsContainer>
      <WidthContainer noBackground>
        <Image
          src={`${VITE_CDN_BASE_URL}/images/image-terminal-with-pata.webp`}
          alt="Dog hydrotherapist using the PataPay card reader to pay payments in person"
          height={1500}
          width={2500}
        />
        <BusinessBenefitsContent>
          <h2>
            Flexible payment methods for canine hydrotherapists with <span>PataPay</span>
          </h2>
          <p>
            Whether clients prefer to pay online or in person for single or repeat sessions, Pata makes charging for
            services easy with deposits, card readers, and payment links.
          </p>

          <ul>
            <li>Take upfront payments to reduce cancellations and no-shows</li>
            <li>Collect and securely store payment card details for any future no-show fees</li>
            <li>Use a Pata card reader with Apple/Google Pay support for in-person payments</li>
            <li>Stay in control with full transaction history on our hydrotherapy booking software</li>
            <li>Unlocked with low processing fees per payment and no monthly charges</li>
          </ul>

          <ActionContainer>
            <Button onClick={handlePataPayLink}>Find out more</Button>
          </ActionContainer>
        </BusinessBenefitsContent>
      </WidthContainer>
    </BusinessBenefitsContainer>
  );
};
